module.exports = __webpack_public_path__ + "img/Group 3015.dab312dc.svg";